import { createSelector } from 'reselect'

export const selectedDashboard = state => state.dashboard

export const selectSelectedFilters = createSelector(selectedDashboard, dashboard => dashboard.filters)
